import React from 'react';
import { BellIcon, StarIcon, RefreshCwIcon, ZapIcon } from 'lucide-react';
export function Benefits() {
  return <section className="py-16 bg-white" data-id="element-63">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="text-center mb-16" data-id="element-65">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-66">
            Why Choose Sunton Florist
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-67">
            Our subscription service offers unique benefits that set us apart
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-68">
          <div className="flex" data-id="element-69">
            <div className="mr-4 flex-shrink-0" data-id="element-70">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center" data-id="element-71">
                <BellIcon className="h-6 w-6 text-pink-700" data-id="element-72" />
              </div>
            </div>
            <div data-id="element-73">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-74">
                Never Miss Important Dates
              </h3>
              <p className="text-gray-600" data-id="element-75">
                Our AI-powered system sends timely reminders for birthdays,
                anniversaries, and special occasions, ensuring you never forget
                to send flowers when it matters most.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-76">
            <div className="mr-4 flex-shrink-0" data-id="element-77">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center" data-id="element-78">
                <StarIcon className="h-6 w-6 text-pink-700" data-id="element-79" />
              </div>
            </div>
            <div data-id="element-80">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-81">
                Personalized Experience
              </h3>
              <p className="text-gray-600" data-id="element-82">
                We learn your preferences over time to create arrangements that
                match your style perfectly. Each delivery is tailored to your
                taste and the recipient's preferences.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-83">
            <div className="mr-4 flex-shrink-0" data-id="element-84">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center" data-id="element-85">
                <RefreshCwIcon className="h-6 w-6 text-pink-700" data-id="element-86" />
              </div>
            </div>
            <div data-id="element-87">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-88">
                Flexible Subscription Management
              </h3>
              <p className="text-gray-600" data-id="element-89">
                Easily pause, skip, or modify your subscription anytime through
                our user-friendly dashboard. We adapt to your changing needs
                without any hassle.
              </p>
            </div>
          </div>
          <div className="flex" data-id="element-90">
            <div className="mr-4 flex-shrink-0" data-id="element-91">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center" data-id="element-92">
                <ZapIcon className="h-6 w-6 text-pink-700" data-id="element-93" />
              </div>
            </div>
            <div data-id="element-94">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-95">
                Loyalty Rewards Program
              </h3>
              <p className="text-gray-600" data-id="element-96">
                Earn points with every delivery that can be redeemed for free
                flowers, premium vases, or exclusive add-ons. Our loyal
                customers enjoy special perks and early access to seasonal
                collections.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-16 bg-pink-50 rounded-2xl p-8 md:p-12" data-id="element-97">
          <div className="md:flex items-center" data-id="element-98">
            <div className="md:w-2/3 mb-6 md:mb-0 md:pr-8" data-id="element-99">
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-100">
                Join Our Sunton Florist Community
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-101">
                Subscribe to our newsletter to receive seasonal flower care
                tips, exclusive offers, and be the first to know about new
                collections and special promotions.
              </p>
              <div className="flex flex-col sm:flex-row gap-3" data-id="element-102">
                <input type="email" placeholder="Enter your email" className="px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent flex-grow" data-id="element-103" />
                <button className="px-6 py-3 bg-pink-700 text-white rounded-md hover:bg-pink-800 transition-colors whitespace-nowrap" data-id="element-104">
                  Subscribe Now
                </button>
              </div>
            </div>
            <div className="md:w-1/3" data-id="element-105">
              <img src="https://images.unsplash.com/photo-1508610048659-a06b669e3321?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80" alt="Beautiful flower arrangement" className="rounded-lg w-full h-auto" data-id="element-106" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}